import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import LyricsShadowColorListItem from './LyricsShadowColorListItem';
import LyricsShadowBlurListItem from './LyricsShadowBlurListItem';
import LyricsShadowOpacityListItem from './LyricsShadowOpacityListItem';
import LyricsShadowDistanceListItem from './LyricsShadowDistanceListItem';
import LyricsShadowAngleListItem from './LyricsShadowAngleListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';

const LyricsShadowListItem = (props) => {
    const { shadowSettingsEnabled, updateLyricsStyle } = props;

    const onShadowEnabledChange = (value) => updateLyricsStyle({ 
        shadowSettings: { enabled: value }
    });
    
    return (
        <CollapsibleSwitchListItem
            checked={shadowSettingsEnabled}
            text='Shadow'
            onChange={onShadowEnabledChange}
        >
            <List dense disablePadding>
                <LyricsShadowColorListItem />
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <LyricsShadowBlurListItem />
                        },
                        {
                            width: 6,
                            component: <LyricsShadowOpacityListItem />
                        }
                    ]}
                />
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <LyricsShadowDistanceListItem />
                        },
                        {
                            width: 6,
                            component: <LyricsShadowAngleListItem />
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { shadowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const shadowSettingsEnabled = shadowSettings ? shadowSettings.enabled : false;
    return { shadowSettingsEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsShadowListItem);
